import clientsListProjects from './modules/store'

export const modules = {
  clientsListProjects
}



// WEBPACK FOOTER //
// ./src/store/Clients/index.js